<template>
  <img
    src="~/assets/icon/copy.svg"
    alt=""
  />
</template>
